import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from "@sundae/ui-toolkit";
import { memo } from "react";
import { Trans } from "react-i18next";
const ErrorFallbackMessage = memo(() => {
    return (_jsx(Text, { tag: "div", className: "grid gap-2", children: _jsxs(Trans, { i18nKey: "message", ns: "error", children: ["A log of this error has been created.", _jsx(Text, { tag: "div", weight: "semibold", variant: "muted", children: "Please tell SundaeSwap about this problem." }), "We have created an error report that you can send to help us improve the platform."] }) }));
});
export default ErrorFallbackMessage;
//# sourceMappingURL=ErrorFallbackMessage.trans.js.map